import gql from 'graphql-tag';

export const addStranka = gql`
    mutation addStranka($input: [StrankaInput!]!){
      response: addStranka(inputStranka: $input){
        id
      }
    }
`;
